<template>
  <el-dialog
    title="通过审核"
    :visible.sync="visible"
    append-to-body
    width="500px"
  >
    <el-form
      :model="ruleForm"
      size="small"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      class="orgForm"
    >
      <el-form-item label="公证员">
        <el-input
          disabled
          v-model="ruleForm.notaryPublic"
          placeholder="公证员名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="公证视频" prop="videoUrl">
        <el-select v-model="ruleForm.videoUrl" placeholder="请选择">
          <el-option
            v-for="item in userList"
            :key="item.name"
            :label="item.name"
            :value="item.url"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div class="tip" style="padding-left: 30px; line-height: 1.3">
        提示：请在已经上传过公证告知视频的公证员中选择一位，此选择将作为本项线上公证告知视频播放者和卷宗默认受理者，请及时通知该公证员！
      </div>

      <!-- <el-form-item label="公证视频上传">
        <el-upload
          class="avatar-uploader"
          action="#"
          name="file"
          ref="upload"
          accept="video/*"
          :on-change="onChange"
          :http-request="upLoadFile"
          :auto-upload="false"
          :on-remove="handleRemove"
          :file-list="fileList"
          :multiple="false"
          :limit="1"
          >
          <el-button size="small" type="primary" :disabled="fileList.length>0">点击上传</el-button>
        </el-upload>
      </el-form-item> -->

      <el-form-item>
        <el-button size="small" :disabled="ruleForm.videoUrl === ''" @click="play">预览视频</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="submitForm('ruleForm')"
          >通过审核</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 视频预览 -->
    <VideoPlayer ref="videoPlayer"/>
    <!-- <el-dialog
      title="视频预览"
      :visible.sync="shopApp"
      append-to-body
      width="500px">
      </el-dialog> -->
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import VideoPlayer from "@/components/videoPlayer.vue";
export default {
  props: {
    templateId: {
      type: Number,
      required: true,
    },
  },
  components: {
    VideoPlayer
  },
  data() {
    return {
      visible: false,
      ruleForm: {
        notaryPublic: "",
        videoUrl: "",
      },
      rules: {
        notaryPublic: [
          {
            required: true,
            message: "请选择输入公证员姓名！",
            trigger: "blur",
          },
        ],
        videoUrl: [
          { required: true, message: "请先上传公证视频！", trigger: "change" },
        ],
      },
      fileList: [],
      loading: false,
      userList: [],
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "login/userInfo", // 公证事项
    }),
  },
  watch: {
    templateId: {
      immediate: true,
      handler() {
        this.ruleForm.notaryPublic = '';
        this.ruleForm.videoUrl = '';
        this.ruleForm.notaryPublic = this.userInfo.notaryName;
      }
    }
  },
  mounted() {
    console.log(this.userInfo)
    
    this.getUserList();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.passAudit()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    // 移除文件
    handleRemove(file, fileList) {
      this.fileList = fileList;
      console.log(fileList);
    },
    // 改变文件
    onChange(file, fileList) {
      this.fileList = fileList;
      console.log(fileList);
    },
    // 上传到文件服务器
    upLoadFile(data) {
      this.loading = true;
      let param = new FormData();
      param.append("file", data.file);
      this.$api
        .upLoadFile(param)
        .then((res) => {
          this.ruleForm.videoUrl = res.data.data.urf;
          this.passAudit();
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    // 通过审核
    passAudit() {
      this.loading = true;
      this.$api
        .passAudit({
          templateId: this.templateId,
          notaryVideo: this.ruleForm.videoUrl,
          notaryPublic: this.ruleForm.notaryPublic,
        })
        .then((res) => {
          if (res) {
            this.close();
            this.$emit("passSuccess");
          }
          // this.$successCallback(res, "审核通过", () => {
          //   this.close();
          //   this.$emit("passSuccess");
          // });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 获取已经创过视频的用户
    getUserList() {
      this.$api
        .userList({
          pageSize: 11000,
          pageNum: 1,
          urlFlag: 1,
        })
        .then((res) => {
          if (res.data.code === "200") {
            this.userList = res.data.data.records;
          }
        });
    },
    play() {
      this.$refs.videoPlayer.open(this.ruleForm.videoUrl)
    }
  },
};
</script>
<style scoped>
.el-form-item {
  margin-bottom: 12px;
}
</style>